import React from 'react';
import { Router } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { withAppContext } from '../../contexts/AppContext';
import AppContextProps from '../../contexts/AppContextProps';
import Footer from '../common/Footer';
import Header from '../common/Header';
import NotFound from '../common/NotFound';
import BrowserHistory from '../utils/BrowserHistory';
import Login from './Login';
import { AppLayout } from '@amzn/awsui-components-core';

const UnAuthContents: React.FC<AppContextProps> = () => {
  return (
    <Router history={BrowserHistory}>
      <div className={'site-container'}>
        <Header />
        <main className="awsui main-content">
          <AppLayout
            navigationHide
            toolsHide
            content={
              <Switch>
                <Route exact path="/" />
                <Route exact path="/login" component={Login} />
                <Route component={NotFound} />
              </Switch>
            }
            ariaLabels={{
              navigation: 'Navigation',
              tools: 'Help panel',
            }}
          />
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default withAppContext(UnAuthContents);
